import {ref} from 'vue';
import {defineStore} from 'pinia';
import {
    Configuration,
    InstantConversationApi,
    PublicInstantConversationApi,
    type CreateInstantConversationRequest,
    type CreatePublicDraftInstantConversationRequest,
    type FinalizeDraftInstantConversationRequest,
} from '@api';
import type {InstantConversationUsage} from '~/types/domain/InstantConversationUsage';

export const useInstantConversationStore = defineStore('instant-conversation', () => {
    const _apiConfiguration = new Configuration({basePath: ''});
    const _instantConversationApi = new InstantConversationApi(_apiConfiguration);
    const _publicInstantConversationApi = new PublicInstantConversationApi(_apiConfiguration);

    // Exposed refs a-z
    const instantConversationLimitReached = ref<boolean>(false);
    const instantConversationUsage = ref<InstantConversationUsage>();

    // Functions a-z
    async function createDraftInstantConversation(payload: CreatePublicDraftInstantConversationRequest): Promise<string> {
        return await _publicInstantConversationApi.createPublicDraftInstantConversation({createPublicDraftInstantConversationRequest: payload});
    }
    async function createInstantConversation(payload: CreateInstantConversationRequest): Promise<string> {
        return await _instantConversationApi.createInstantConversation({createInstantConversationRequest: payload});
    }

    async function finalizeDraftInstantConversation(payload: FinalizeDraftInstantConversationRequest): Promise<string> {
        return await _instantConversationApi.finalizeDraftInstantConversation({finalizeDraftInstantConversationRequest: payload});
    }

    async function loadInstantConversationUsage(): Promise<void> {
        const {usage, limit} = await _instantConversationApi.getInstantConversationUsageForUser();
        instantConversationUsage.value = {usage, limit};
        instantConversationLimitReached.value = usage >= limit;
    }

    return {
        // refs a-z
        instantConversationLimitReached,
        instantConversationUsage,
        // functions a-z
        createDraftInstantConversation,
        createInstantConversation,
        finalizeDraftInstantConversation,
        loadInstantConversationUsage,
    };
});
